module.exports = __webpack_public_path__ + "static/media/depotTownClock.64c86970.jpg";